import PropTypes from "prop-types";
import { block } from "bem-cn";
import { useStaticQuery, graphql } from "gatsby";

import Heading from "components/Heading";
import Title from "components/Title";
import Link from "components/Link";

import "./style.scss";

const cn = block("main-contacts-card");

const ContactField = ({ title, children }) => (
  <div className={cn("address", { wrap: true })}>
    <Title isBlock weight="bold" level={5}>
      {title}
    </Title>
    <address className={cn("address", { text: true })}>{children}</address>
  </div>
);

const ContactsCard = ({ className }) => {
  const data = useStaticQuery(graphql`
    query ContactDataQuery {
      site {
        siteMetadata {
          company
          address
          phone
          email
        }
      }
    }
  `);

  const { company, address, phone, email } = data.site.siteMetadata;

  return (
    <section className={cn("wrap").mix(className)}>
      <Heading weight="bold" level={5} className={cn("title")}>
        {company}
      </Heading>
      <ContactField title="Address">
        <Title>{address}</Title>
      </ContactField> 
      <ContactField title="Phone">
        <Link
          isOutside
          href={`tel:${phone}`}
          className={cn("address", { text: "phone" })}
        >
          {phone}
        </Link>
      </ContactField>
      <ContactField title="Email">
        <Link isOutside href={`mailto:${email}`} color="primary">
          {email}
        </Link>
      </ContactField>
    </section>
  );
};

ContactsCard.propTypes = {
  className: PropTypes.object,
};

export default ContactsCard;
